<template>
  <component :is="el" ref="animatedText" class="animated-text" v-bind="$attrs" v-on="$listeners">
    <div ref="slot" class="animated-text__slot">
      <slot />
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div ref="animation" class="animated-text__animation" v-html="animationInnerHTML" />
  </component>
</template>

<script>
import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';

export default {
  name: 'AnimatedText',

  props: {
    el: {
      type: String,
      default: 'span',
    },
  },

  data() {
    return {
      textTimeline: null,
      splitText: null,

      slotInnerHTML: '',
      animationInnerHTML: '',
    };
  },

  mounted() {
    // wait for parent to fill slot
    this.$nextTick(() => {
      this.slotInnerHTML = this.$refs.slot.innerHTML;

      this.$on('hook:updated', () => {
        this.slotInnerHTML = this.$refs.slot.innerHTML;
      });
      this.$watch('slotInnerHTML', this.onSlotInnerHTMLChange, { immediate: true });

      this.$router.beforeEach(async (to, from, next) => {
        if (this.splitText) await this.textTimeline.reverse();
        next();
      });
    });
  },

  methods: {
    async onSlotInnerHTMLChange(slotInnerHTML) {
      if (this.textTimeline && this.textTimeline.isActive()) {
        await this.textTimeline;
      }

      if (this.splitText) await this.textTimeline.reverse();

      this.animationInnerHTML = slotInnerHTML;
      if (!slotInnerHTML) {
        this.splitText = null;
        this.textTimeline = null;
        return;
      }

      await this.$nextTick();
      this.initAnimation();
    },

    initAnimation() {
      this.splitText = new SplitText(this.$refs.animation, { type: 'words' });
      this.textTimeline = gsap.timeline().from(
        this.splitText.words,
        {
          duration: 0.325,
          opacity: 0,
          y: 30,
          transformOrigin: '0% 50% -50',
          ease: 'power3.out',
          stagger: 0.05,
        },
        '+=0'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.animated-text {
  position: relative;
  font-kerning: none;
  transform: translateZ(0);
}

// hide real slot content
.animated-text__slot {
  opacity: 0;
  position: absolute;
  user-select: none;
  pointer-events: none;
  z-index: -1;
}
</style>
